import {NfMessage, NfMessageType} from "../NfMessage";
import type {BookingEngineConfigModel} from "../Models/BookingEngineConfigModel";
import {NfGlobalMessage} from "../NfGlobalMessage";

/**
 * Konfiguracja widgeta, do booking engine
 */
export class GetBookingEngineConfigurationResult extends NfGlobalMessage {
    public constructor(widgetId: number|MessageEvent<GetBookingEngineConfigurationResult>, configuration?: BookingEngineConfigModel) {
        super(NfMessageType.GetBookingEngineConfigurationResult, arguments.length > 1);
        if(NfMessage.isMessageEvent(widgetId)) {
            Object.assign(this, widgetId.data);
        } else {
            this.widgetId = widgetId;
            if(!configuration) {
                throw Error('configuration parameter is required');
            }
            this.configuration = configuration;
        }
    }
    public type = NfMessageType.GetBookingEngineConfigurationResult;
    /**
     * id widgeta dla backendu nfHotel
     */
    public widgetId:number = 0;
    public configuration: BookingEngineConfigModel|null = null;
}
NfMessage.creationCallbacks[NfMessageType.GetBookingEngineConfigurationResult] = (event) => {
    return new GetBookingEngineConfigurationResult(event);
}
